<template slot="inview" slot-scope="{ action, hasEnter, hasLeave }">

  <div class="ServicePackage">

    <div class="maxContainer">
      <!-- <a @click="goBack()">Go back</a> -->
      
      <div class="ServicePackage__row mt-8" v-if="primaryProducts.length" :class="[this.selected.tagoptions == 'PERSONAL_STATEMENTS' ? 'personalStatementPage' : '']">

        <PackageCard v-for="(item, index) in primaryProducts"
                      :key="item.id"
                      :data="item"
                      :number="index"
                      @onSubmit="choosePackage" ></PackageCard>
      </div>


    </div>

  </div>
</template>

<script>

import PackageCard from '@/components/Services/PackageCard'
import { handleize } from '@/lib/utils'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ServicePackage',
  components: {
    PackageCard
  },
  props: [
    'selected',
    'packages'
  ],
  data () {
    return {}
  },
  mounted () {
    console.log('-ServicePackage->' , this.selected, this.packages)
  },
  methods: {
    ...mapActions('services', ['setCartItems']),
    goBack () {
      this.$emit('goBack')
    },
    showNextStep (event) {
      this.$emit('onSubmit',{package : event})
    },
    choosePackage ({ items = [] }) {
      this.setCartItems(items)
      this.$router.push(`/services/purchase`)
    }
  },
  computed: {
    ...mapState('services', ['allProducts']),
    primaryProducts () {

      let sorted = this.packages.sort(function(a,b){
        return a.data.order - b.data.order
      })

      return sorted.filter(p => p.tags.includes(this.selected.tagoptions) && !p.data.depends_on_service.id)
    }
  },
  unmount () {
    // window.removeEventListener('message', this.handlePostMessage)
  }
}
</script>
<style scoped>
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.responiveImage {
  display: block;
  width: 100%;
}
@media (min-width: 769px) {
  .ServicePackage {
    padding-top: 60px;
  }
}

.ServicePackage__row {
  padding-bottom: 100px;
}

.ServicePackage__row.type2 {
  text-align: right;
}

.ServicePackage__imageCover {
  position: relative;
  width: 40%;
  display: inline-block;
  vertical-align: bottom;
  margin-left: 5%;
  z-index: 3;
}

.type2 .ServicePackage__imageCover {
  margin-left: 0;
  vertical-align: middle;
  width: 45%;
}

.ServicePackage__imageCover::before {
  content: '';
  display: block;
  width: 100%;
  padding-bottom:  calc(1177/1066 * 100%);
}

.ro1::before {
  padding-bottom: 100%;
}

.ServicePackage__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ServicePackage__textCover {
  background-color: #BACDD9;
  width: 50%;
  display: inline-block;
  vertical-align: bottom;
  padding: 100px 50px 50px 175px;
  margin: 50px 0 -50px -125px;
}

.type2 .ServicePackage__textCover {
  text-align: right;
  padding: 100px 175px 50px 50px ;
  margin: 50px -125px -50px 0;
}

.ServicePackage__textCover .miniTitle {
  color: #191340;
  font-size: 12px;
}

.ServicePackage__textCover .title {
  color: #191340;
  font-size: 22px;
  position: relative;
  padding-bottom: 41px;
}

.ServicePackage__textCover .list {
  padding-bottom: 16px;
}

.ServicePackage__textCover .title::before {
  content: '';
  background-color: #191340;
  height: 2px;
  width: 30px;
  display: block;
  position: absolute;
  bottom: 20px;
  left: 0;
}

.type2 .ServicePackage__textCover .title::before {
  left: auto;
  right: 0;
}

.ServicePackage__textCover .text {
  color: #191340;
  font-size: 16px;
}

.ServicePackage__rowbg {
  background: url('../../assets/services/03_opt.jpg') no-repeat center bottom;
  height: 400px;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-self: center;
  margin-top: 50px;
  margin-bottom: 100px;
  position: relative;
}
.ServicePackage__rowbg::before {
  content: '';
  background-color: #BACDD9;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: .6;
  z-index: 1;
}

.ServicePackage__rowbgCover {
  position: relative;
  z-index: 2;
  display: inline-block;
  padding: 20px;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}

.ServicePackage__rowbgTitle {
  font-size: 24px;
  margin-bottom: 30px;
  max-width: 620px;
}

.blockquote-wrapper {
   display: flex;
   padding: 0 20px;
}

/* Blockquote main style */
.blockquote {
    position: relative;
    max-width: 620px;
    margin: 0 auto;
    align-self: center;
}

.blockquote h1 {
    position: relative; /* for pseudos */
    color: #e74848;
    font-size: 2.8rem;
    font-weight: normal;
    line-height: 1;
    margin: 0;
    border: 2px solid #ccc;
    border: solid 2px;
    border-radius:20px;
    padding: 25px;
}

/* Blockquote right double quotes */
.blockquote h1:after {
    content:"";
    position: absolute;
    border: 2px solid #e74848;
    border-radius: 0 50px 0 0;
    width: 60px;
    height: 60px;
    bottom: -60px;
    left: 50px;
    border-bottom: none;
    border-left: none;
    z-index: 3;
}

.blockquote h1:before {
    content:"";
    position: absolute;
    width: 80px;
    border: 6px solid #ffffff;
    bottom: -3px;
    left: 50px;
    z-index: 2;
}

/* increase header size after 600px */
@media all and (min-width: 600px) {
    .blockquote h1 {
        font-size: 3rem;
        line-height: 1.2;
   }

}

.blockquote h4 {
    position: relative;
    color: #000;
    font-size: 1.3rem;
    font-weight: 400;
    line-height: 1.2;
    margin: 0;
    padding-top: 15px;
    z-index: 1;
    margin-left:150px;
    padding-left:12px;
}


.blockquote h4:first-letter {
  margin-left:-12px;
}

.ServicePackage__rowCoverText {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}
.animateMe {
  opacity: 0;
  transform: translate(0, 40px);
  transition: all .5s ease-in .1s;
}
.animateMeLeft {
  opacity: 0;
  transform: translate(-100px, 0);
  transition: all .5s ease-in .1s;
}

.animateMeRight {
  opacity: 0;
  transform: translate(100px, 0);
  transition: all .5s ease-in .1s;
}

.animateShow {
  opacity: 1;
  transform: translate(0, 0);
}

.ServicePackage__row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicePackage.vue